//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { FlatPrimaryButton } from '@components/atoms/button/Button';
import Icon from '@components/atoms/icon/Icon';
import { BodyBoldText } from '@components/atoms/text/Text';

interface VariantsHeaderProps {
  isViewOnly: boolean;
  onRemoveAll: () => void;
}

export const VariantsHeader = ({
  isViewOnly,
  onRemoveAll,
}: VariantsHeaderProps) => {
  return (
    <Container>
      <BodyBoldText>Variants</BodyBoldText>
      {!isViewOnly && (
        <StyledFlatPrimaryButton
          onClick={onRemoveAll}
          trackingId={
            SAMPLING_CAMPAIGNS_TRACKING_ID.PRODUCT_MODAL_INPUT_FIELD_REMOVE_ALL_VARIATIONS
          }
        >
          <StyledIcon name='delete' />
          Remove all
        </StyledFlatPrimaryButton>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacings[4]};
`;

const StyledFlatPrimaryButton = styled(FlatPrimaryButton)`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  margin-right: ${({ theme }) => theme.spacings[2]};
  vertical-align: middle;
`;
